<template>
  <span v-if="hasTranslation">
    <v-text-field
      v-bind="$attrs"
      :modelValue="modelValue"
      :label="labelText"
      :hint="hintText"
      :persistent-hint="persistentHint"
      :persistent="persistent"
      :active="active"
      :autofocus="autofocus"
      :bg-color="bgColor"
      :base-color="baseColor"
      :variant="variant"
      :type="type"
      :prepend-icon="prependIcon"
      :append-icon="appendIcon"
      @input="$emit('update:modelValue', $event.target.value)"
      @update:focused="$emit('update:focused', true)"
      @click:prepend="$emit('click:prepend', true)"
      @click:append="$emit('click:append', true)"
    />
  </span>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState, mapGetters } from 'pinia'
import { defineModel } from 'vue'

// import { defineAsyncComponent } from 'vue'

export default {
  name: 'I18nTextField',
  components: {},
  emits: [
    'update:modelValue',
    'update:focused',
    'click:prepend',
    'click:append'
  ],
  props: {
    modelValue: {},
    i18nlabel: {
      type: String,
      required: true
    },
    i18nhint: {
      type: String,
      required: false,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false
    },
    persistent: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
      type: Boolean,
      required: false,
      default: true
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    bgColor: {
      type: String,
      required: false,
      default: 'var(--color-white)'
    },
    baseColor: {
      type: String,
      required: false,
      default: 'var(--color-white)'
    },
    variant: {
      type: String,
      required: false,
      default: 'solo'
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    prependIcon: {
      type: String,
      required: false,
      default: ''
    },
    appendIcon: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      labelText: '',
      hintText: '',
      hasTranslation: false,
      inputValue: '', //defineModel(),
      value: ''
    }
  },
  beforeMount() {
    // console.log('i18nTextField GOT BEFORE MOUNT !')
  },
  mounted() {
    // console.log('TEXT FIELD ARE  (%s)', this.modelValue)
    // console.log('Label (%s)', this.i18nlabel)
    // console.log('HING (%s)', this.i18nhint)
    this.geti18nTranslation(this.i18nlabel).then((result) => {
      // console.log('i18nTextField TRANSLATE TEXT (%s)', result)
      this.labelText = result
      this.geti18nTranslation(this.i18nhint).then((res2) => {
        this.hintText = res2
        this.hasTranslation = true
      })
    })
  },
  methods: {
    ...mapActions(adminStore, ['geti18nTranslation']),
    ...mapGetters(adminStore, ['getTranslationMap'])
  }
}
</script>

<style scoped></style>
